import React from "react";
import { SolutionState } from "../../types/Solutions";
import { LinearProgress, Tooltip } from "@mui/material";

const Progress = (props: { state: SolutionState }) => {

  const color = () => {
    switch (SolutionState[props.state]) {
      case SolutionState.assigned:
        return "warning";
      case SolutionState.defined:
        return "secondary";
      case SolutionState.resolved:
        return "success";
      default:
        return "error";
    }
  }

  return <Tooltip title={props.state.toString().toUpperCase()}>
    <LinearProgress 
            color={color()}
            variant="determinate" 
            value={SolutionState[props.state]} />
  </Tooltip>
}

export default Progress;